import React, { Component } from "react";

export default class PageLargeText extends Component {
  	
	render () {
		
		let block = this.props.block;
		
		let blockClass = 'c-page__block c-page__block--load-effect';
		
		if (block.rule === true) {
			blockClass = blockClass + ' c-page__block--border-bottom';	
		}
		
		if (block.space_after === 'small') {
			blockClass = blockClass + ' c-page__block--small-space';	
		} else if (block.space_after === 'text') {
			blockClass = blockClass + ' c-page__block--text-space';	
		} else if (block.space_after === 'margin') {
			blockClass = blockClass + ' c-page__block--margin-space';	
		}
			
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={blockClass}>
			    			    		
		    		<div className="l-grid">
		    		
		    			<div className="l-grid__col">
		    			
		    				{block.text &&
		    			
			    				<div className="scope-text scope-text--large" dangerouslySetInnerHTML={{__html:block.text}}></div>
							
							}
							
						</div>
								    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
